<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-msg-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="dialog-text" v-html="text"></div>

                    <div class="u-btn ok" @click="destroyElement"></div>
                </div>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            text : '',
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
    },
}
</script>

<style scoped>
/* share */
.m-msg-modal {
    width: 504px;
    height: 304px;
    background-image: url(~@/assets/images/utils/bg-modal-smsg.png);
}

.dialog-wrapper{
    padding: 90px 40px 0;
}

.dialog-text {
    font-size: 22px;
    color: #c03b20;
    text-align: center;
    word-break: break-all;
}

.dialog-text p{
    margin-bottom: 4px;
}


.u-btn.ok {
    position: absolute;
    left: 50%;
    bottom: 42px;
    width: 222px;
    height: 66px;
    margin-left: -111px;
    background-image: url(~@/assets/images/utils/btn-ok.png);
}
</style>


// WEBPACK FOOTER //
// src/components/MsgModalSmall/msgModal.vue